var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnUserName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;fill:#F5F5F5;}\r\n\t.st2{fill:none;}\r\n\t.st3{fill:#CBCBCB;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 24,
    height: 24
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M12,6c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S10.9,6,12,6 M12,16c2.7,0,5.8,1.3,6,2H6C6.2,17.3,9.3,16,12,16  M12,4C9.8,4,8,5.8,8,8s1.8,4,4,4s4-1.8,4-4S14.2,4,12,4z M12,14c-2.7,0-8,1.3-8,4v2h16v-2C20,15.3,14.7,14,12,14z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnUserName);
export default __webpack_public_path__ + "static/media/icn_user-name.685485de38cca7ac835f18867b78e3e5.svg";
export { ForwardRef as ReactComponent };